import {Funcionario} from "./funcionario";

export class ColaboradorAcao {

    id: number;
    funcionario: Funcionario;
    idUsuario: number;

}